import { Instagram, Facebook, Youtube, Twitter, Mail, Phone } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function Footer({ settings = {} }) {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {settings.logo_file_id ? (
              <img src={fileUrl(settings.logo_file_id)} alt="NDPL" className="w-12 h-12 rounded-full object-cover ring-1 ring-[#FFD700]/40" />
            ) : (
              <div className="w-10 h-10 rounded-md bg-[#39FF14] text-black grid place-items-center font-display text-2xl">N</div>
            )}
            <div>
              <div className="font-display text-3xl">NDPL</div>
              <div className="text-[10px] tracking-[0.3em] text-[#FFD700]">T10 PREMIER LEAGUE</div>
            </div>
          </div>
          <p className="text-sm text-white/60">The T10 cricket revolution of Nagaur & Didwana. Register. Trial. Get drafted. Play.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#39FF14] mb-4">Quick Links</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="#about" className="hover:text-[#39FF14]">About</a></li>
            <li><a href="#prize" className="hover:text-[#39FF14]">Prize Pool</a></li>
            <li><a href="/register" className="hover:text-[#39FF14]">Registration</a></li>
            <li><a href="#faqs" className="hover:text-[#39FF14]">FAQs</a></li>
          </ul>
        </div>
        <div id="contact">
          <div className="text-xs uppercase tracking-widest text-[#39FF14] mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-center gap-2"><Mail size={14}/> {settings.contact_email || "contact@ndpl.in"}</li>
            <li className="flex items-center gap-2"><Phone size={14}/> {settings.contact_phone || "+91 90000 00000"}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#39FF14] mb-4">Follow</div>
          <div className="flex gap-3">
            {settings.social_instagram && <a href={settings.social_instagram} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#39FF14] hover:text-[#39FF14]"><Instagram size={16}/></a>}
            {settings.social_facebook && <a href={settings.social_facebook} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#39FF14] hover:text-[#39FF14]"><Facebook size={16}/></a>}
            {settings.social_youtube && <a href={settings.social_youtube} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#39FF14] hover:text-[#39FF14]"><Youtube size={16}/></a>}
            {settings.social_twitter && <a href={settings.social_twitter} target="_blank" rel="noreferrer" className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#39FF14] hover:text-[#39FF14]"><Twitter size={16}/></a>}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-xs text-white/40">© 2026 NDPL. All rights reserved.</div>
        <div className="text-xs text-white/40">Nagaur • Didwana • Rajasthan</div>
      </div>
    </footer>
  );
}
